<div class="pcn-details" [ngClass]="{'hidden': global.pcnPrepopulateLoading}">
  <div class="pcn-burger" [ngClass]="{'active': isPcnPanelVisible}"
       (click)="isPcnPanelVisible = !isPcnPanelVisible">
    <div class="arrow-left">&#8592;</div>PCN<div class="arrow-right">&#8594;</div>
  </div>
  <div class="left-container" [ngClass]="{'opened': isPcnPanelVisible}">
    <pcn-block></pcn-block>
  </div>
  <div class="right-container">
    <welcome></welcome>
  </div>
</div>

<div class="rm-spinner-wrapper" *ngIf="global.pcnPrepopulateLoading">
  <div class="rm-spinner-text">{{ loadingMessage }}</div>
  <div class="rm-spinner" [ngClass]="spinnerStyle"></div>
</div>

<!-- Deliberately outside the hidden wrapper above (not inside pcn-block.component.html), so it is
     never affected by pcnPrepopulateLoading's 'hidden' class regardless of how the underlying
     kendo-dialog renders itself. Driven via the ViewChild reference rather than duplicating
     pcn-block's state here. -->
<pcn-confirmation-modal
  [confirmations]="pcnBlockComponent?.pendingConfirmations"
  (confirmed)="pcnBlockComponent?.onConfirmationsResolved($event)"
  (closed)="pcnBlockComponent?.onConfirmationCancelled()"
></pcn-confirmation-modal>

